import { render, staticRenderFns } from "./DeviceViewExclusions.vue?vue&type=template&id=5beac0b9&scoped=true&"
import script from "./DeviceViewExclusions.vue?vue&type=script&lang=js&"
export * from "./DeviceViewExclusions.vue?vue&type=script&lang=js&"
import style0 from "./DeviceViewExclusions.vue?vue&type=style&index=0&id=5beac0b9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5beac0b9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5beac0b9')) {
      api.createRecord('5beac0b9', component.options)
    } else {
      api.reload('5beac0b9', component.options)
    }
    module.hot.accept("./DeviceViewExclusions.vue?vue&type=template&id=5beac0b9&scoped=true&", function () {
      api.rerender('5beac0b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/device/DeviceViewExclusions.vue"
export default component.exports